import SearchInput from "./SearchInput.vue"
const components = [];
components.push(SearchInput);

var install = (Vue) => {
    components.forEach((component) => {
        Vue.component(component.name, component)
    })
}
export default install;